import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDe = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "flag-icons-de",
	viewBox: "0 0 640 480",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#fc0",
			d: "M0 320h640v160H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#000001",
			d: "M0 0h640v160H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "red",
			d: "M0 160h640v160H0z"
		})
	]
});
export default SvgDe;
